import {ParamsProps} from '@/components/WdiBus/FormPage';
import {Enum} from '@/enums/system';
import {ResponseStatus} from '@/utils/request';
import {WdiModalAppResult} from '@/components/WdiControls';
import {FormApi} from '@/services/sales';
import {FormSp} from '@/services/sales/sp';

export type ViewEntityProps = {
  form?: API.Form,
  formSp?: API.FormSpPreVo,
  relationType?: number,
  relatedFormId?: number,
  formId?: number;
  statusId?: number;
  formTypeId?: number;
  pageTypeId?: number;
  paymentMethodId?: number,
  payToTypeId?: number;
  companyCode?: string;
  supplierId?: number,
  payToUserId?: number;
  soldToCode?: string;
  formSaId?: number,
  formSsId?: number,
  reimburseType?: number,
  userId?: number;
  positionId?: number;
  deptId?: number;
  ecFieldConfigs?: API.EcFieldConfig[];
}

export const initApplyPageContext = async (params: ParamsProps) => {
  const result: WdiModalAppResult = {
    code: ResponseStatus.UNKNOWN
  };
  const viewEntity: ViewEntityProps = {};
  if (params.formId || params.relatedFormId) {
    // 退回待修改
    const formResponse = await FormApi.get(params.formId || params.relatedFormId || 0);
    viewEntity.form = formResponse.data;
    if (!viewEntity.form) {
      result.message = "无效的退回待修改单";
      return result;
    }
    if (params.formId) {
      viewEntity.formId = params.formId;
    } else {
      viewEntity.relationType = Enum.FormRelationType.REJECTED;
      viewEntity.relatedFormId = params.relatedFormId;
    }

    const formSPResponse = await FormSp.getVo(viewEntity.form.formId);
    viewEntity.formSp = formSPResponse.data;
    viewEntity.reimburseType = viewEntity.formSp.reimburseType;
    viewEntity.paymentMethodId = viewEntity.formSp.paymentMethodId;
    viewEntity.payToTypeId = viewEntity.formSp.payToTypeId;
    viewEntity.companyCode = viewEntity.formSp.companyCode;
    viewEntity.supplierId = viewEntity.formSp.supplierId;
    viewEntity.soldToCode = viewEntity.formSp.soldToCode;
    viewEntity.payToUserId = viewEntity.formSp.payToUserId;
    viewEntity.userId = viewEntity.form.userId;
    viewEntity.positionId = viewEntity.form.positionId;
    viewEntity.deptId = viewEntity.form.deptId;
    viewEntity.pageTypeId = viewEntity.form.pageTypeId;
    viewEntity.formTypeId = viewEntity.form.formTypeId;
  } else {
    // 直接申请
    viewEntity.paymentMethodId = params.paymentMethodId;
    viewEntity.payToTypeId = params.payToTypeId;
    viewEntity.companyCode = params.companyCode;
    viewEntity.supplierId = params.supplierId;
    viewEntity.soldToCode = params.soldToCode;
    viewEntity.payToUserId = params.payToUserId;
    viewEntity.pageTypeId = params.pageTypeId;
    viewEntity.formTypeId = params.formTypeId;
    viewEntity.formSaId = params.formSaId;
    viewEntity.reimburseType = params.reimburseType;
    viewEntity.userId = params.userId;
    viewEntity.positionId = params.positionId;
    viewEntity.deptId = params.deptId;
  }

  result.code = ResponseStatus.SUCCESS;
  result.data = viewEntity;
  return result;
}


export const initApprovalPageContext = async (params: ParamsProps) => {
  const result: WdiModalAppResult = {
    code: ResponseStatus.UNKNOWN
  };
  const viewEntity: ViewEntityProps = {};
  if (params.formId) {
    // 从草稿打开
    const formSPResponse = await FormSp.getVo(params.formId);
    viewEntity.formSp = formSPResponse.data;
    if (!viewEntity.formSp) {
      result.message = "无效的草稿单";
      return result;
    }
    const formResponse = await FormApi.get(params.formId);
    viewEntity.form = formResponse.data;
  }

  result.code = ResponseStatus.SUCCESS;
  result.data = viewEntity;
  return result;
};

// const initFormSpRelation = async (viewEntity:ViewEntityProps)=>{
//   if(!viewEntity?.formSp){
//     return;
//   }
//   if(viewEntity.form?.statusId){
//     const formStatusRes = await DataOptions.search({
//       typeGroup:3,
//       value: viewEntity.form.statusId
//     })
//     const options = formStatusRes?.data;
//     if(options && options.length>0){
//       viewEntity.formStatus = options[0];
//     }
//   }
//
//   if(viewEntity.formSp?.pageTypeId){
//     const pageTypeRes = await PageType.get(viewEntity.formSp.pageTypeId)
//     viewEntity.pageType = pageTypeRes?.data;
//   }
//
//   if (viewEntity.formSp?.paymentMethodId) {
//     const paymentMethodResponse = await DataOptions.search({
//       typeGroup: 5,
//       value: viewEntity.formSp.paymentMethodId
//     });
//     const options = paymentMethodResponse?.data
//     if(options && options.length>0){
//       viewEntity.paymentMethod = options[0];
//     }
//   }
//
//   if(viewEntity.formSp?.payTypeId){
//     const payTypeResponse = await  DataOptions.search({
//       typeGroup: 106,
//       value: viewEntity.formSp.payTypeId
//     });
//     const options = payTypeResponse?.data
//     if(options && options.length>0){
//       viewEntity.payType = options[0];
//     }
//   }
//
//   if (viewEntity.formSp?.supplierId) {
//     const supplierResponse = await Supplier.get(viewEntity.formSp.supplierId);
//     viewEntity.supplier = supplierResponse?.data;
//   }
//
//   if (viewEntity.formSp?.companyCode) {
//     const companyRes = await Company.get(viewEntity.formSp.companyCode);
//     viewEntity.company = companyRes?.data;
//   }
//
//   if(viewEntity.formSp?.bankAccountId){
//     const bankAccountRes =  await BankAccount.get(viewEntity.formSp.bankAccountId);
//     viewEntity.bankAccount = bankAccountRes?.data;
//   }
//
//   if(viewEntity.form?.formId){
//     const formSPDetailsResponse = await FormSpDetail.getFormSpPreDetailsVo(viewEntity.form.formId);
//     viewEntity.formSpDetails = DataStore.init(formSPDetailsResponse.data);
//   }
// }
